/**
 * Product Card Image Preload
 * - Preloads product page image (and secondary) on card hover for instant navigation
 * - Preloads card images in DOM order so they load sequentially (faster perceived load)
 */

(function() {
  'use strict';

  const preloaded = new Set();
  let sequentialIndex = 0;
  let sequentialScheduled = false;

  function preloadUrl(url) {
    if (!url || preloaded.has(url)) return;
    preloaded.add(url);
    const img = new Image();
    img.src = url;
  }

  function preloadProductPageImage(card) {
    const url = card.getAttribute('data-product-page-image');
    const secondary = card.getAttribute('data-secondary-image-url');
    preloadUrl(url);
    preloadUrl(secondary);
  }

  function scheduleSequentialPreload() {
    if (sequentialScheduled) return;
    sequentialScheduled = true;

    function runWhenIdle() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(sequentialPreloadInOrder, { timeout: 2000 });
      } else {
        setTimeout(sequentialPreloadInOrder, 400);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runWhenIdle);
    } else {
      runWhenIdle();
    }
  }

  function sequentialPreloadInOrder() {
    const cards = Array.from(document.querySelectorAll('[data-product-card][data-primary-image]'));
    const LAZY_START_INDEX = 4; // First 4 are eager; preload 5th onward in order

    function preloadNext() {
      if (sequentialIndex >= cards.length) return;
      const card = cards[sequentialIndex];
      const url = card.getAttribute('data-primary-image');
      sequentialIndex += 1;
      if (url) preloadUrl(url);
      // Small delay so images load in order without overwhelming the connection
      setTimeout(preloadNext, 80);
    }

    // Start from 5th card (index 4)
    sequentialIndex = LAZY_START_INDEX;
    preloadNext();
  }

  function bindHoverPreload() {
    document.addEventListener('mouseover', function(e) {
      const card = e.target.closest('[data-product-card]');
      if (card) preloadProductPageImage(card);
    }, { passive: true });

    document.addEventListener('focusin', function(e) {
      const card = e.target.closest('[data-product-card]');
      if (card) preloadProductPageImage(card);
    });
  }

  bindHoverPreload();
  scheduleSequentialPreload();
})();
